import { useEffect, useRef, useState } from 'react';

export function prefersReducedMotion() {
    return (
        typeof window !== 'undefined' &&
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
}

// Returns [ref, isVisible]. Visible immediately under reduced motion or when
// IntersectionObserver is missing. Once visible it stays visible.
export function useReveal(threshold = 0.15) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(
        () => prefersReducedMotion() || typeof IntersectionObserver === 'undefined'
    );

    useEffect(() => {
        const node = ref.current;
        if (visible || !node) return undefined;
        const observer = new IntersectionObserver(
            entries => {
                if (entries.some(entry => entry.isIntersecting)) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold }
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, [visible, threshold]);

    return [ref, visible];
}
